import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IContract } from '../../../model/shared/IContract';

interface IContractAnnexPendingProps {
    contract?: IContract;
    // Who is looking: the influencer is the one who has to sign
    isInfluencer?: boolean;
    // The influencer belongs to an agency, the agency signs for them
    signedByAgency?: boolean;
    onView: () => void;
}

/** Shown in the Contract tab while an amendment of the contract waits for a signature */
export const ContractAnnexPending = ({
    contract,
    isInfluencer,
    signedByAgency,
    onView,
}: IContractAnnexPendingProps) => {
    const { t } = useTranslation();
    const prefix = 'brand.campaign.book.contract.modal.annex';

    if (!contract?.isAnnex || contract.status !== 'pre_annex') {
        return null;
    }

    return (
        <div className="annex-description-card d-flex align-items-center justify-content-between flex-wrap mb-3">
            <span className="me-3">
                {t(
                    `${prefix}.${
                        signedByAgency
                            ? isInfluencer
                                ? 'waiting_for_agency'
                                : 'waiting_for_influencer_agency'
                            : isInfluencer
                            ? 'waiting_for_you'
                            : 'waiting_for_influencer'
                    }`,
                    { number: contract.annexNumber }
                )}
            </span>
            <Button variant="link" size="sm" className="p-0 text-nowrap" onClick={onView}>
                {t(`${prefix}.view_amendment`)}
            </Button>
        </div>
    );
};
